import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CurrencyProvider } from "@/lib/currency";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import CoffeeCustomize from "@/pages/CoffeeCustomize";
import CoffeeCheckout from "@/pages/CoffeeCheckout";
import Admin from "@/pages/Admin";
import WorkoutPlan from "@/pages/WorkoutPlan";
import Corporate from "@/pages/Corporate";
import Suppliers from "@/pages/Suppliers";
import WellnessQuiz from "@/pages/WellnessQuiz";
import MemberLogin from "@/pages/MemberLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MemberDashboard from "@/pages/MemberDashboard";
import AuthCallback from "@/pages/AuthCallback";
import JourneyBuilder from "@/pages/JourneyBuilder";
import JourneyView from "@/pages/JourneyView";
import PlatformHome from "@/pages/PlatformHome";
import DestinationPage from "@/pages/DestinationPage";
import WellnessCalendar from "@/pages/WellnessCalendar";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import TrainBeforeTravel from "@/pages/TrainBeforeTravel";
import CorporateRetreats from "@/pages/CorporateRetreats";
import DietLanding from "@/pages/DietLanding";
import DietHowItWorks from "@/pages/DietHowItWorks";
import DietOnboarding from "@/pages/DietOnboarding";
import DietClient from "@/pages/DietClient";
import GlobalSeries from "@/pages/GlobalSeries";
import NourishTopic from "@/pages/NourishTopic";
import ChatWidget from "@/components/site/ChatWidget";
import MusicPlayer from "@/components/site/MusicPlayer";
import { Tracker } from "@/lib/tracker";
import "@/App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<PlatformHome />} />
      <Route path="/coaching" element={<Landing />} />
      <Route path="/diet" element={<DietLanding />} />
      <Route path="/diet/how-it-works" element={<DietHowItWorks />} />
      <Route path="/diet/onboarding" element={<DietOnboarding />} />
      <Route path="/diet/client" element={<DietClient />} />
      <Route path="/diet/global-series" element={<GlobalSeries />} />
      <Route path="/nourish/:topic" element={<NourishTopic />} />
      <Route path="/destinations/:slug" element={<DestinationPage />} />
      <Route path="/calendar" element={<WellnessCalendar />} />
      <Route path="/journal" element={<Journal />} />
      <Route path="/journal/:slug" element={<Article />} />
      <Route path="/train" element={<TrainBeforeTravel />} />
      <Route path="/retreats" element={<CorporateRetreats />} />
      <Route path="/bootcamps" element={<Landing />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/coffee/customize" element={<CoffeeCustomize />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/coffee/checkout" element={<CoffeeCheckout />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/plan" element={<WorkoutPlan />} />
      <Route path="/corporate" element={<Corporate />} />
      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/wellness-quiz" element={<WellnessQuiz />} />
      <Route path="/journey" element={<JourneyBuilder />} />
      <Route path="/journey/:id" element={<JourneyView />} />
      <Route path="/login" element={<MemberLogin />} />
      <Route path="/dashboard" element={<MemberDashboard />} />
    </Routes>
    {!location.pathname.startsWith("/admin") && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <CurrencyProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <MusicPlayer />
        <Tracker />
        <AppRouter />
      </BrowserRouter>
    </CurrencyProvider>
  );
}

export default App;
